// extracted by mini-css-extract-plugin
export default {"title":"YTTpj_1HwoivZSSCl9E4","cancelPayment":"zinZ8gIMrX7HPcXHfEIM","cancelPaymentDivider":"G3DzNi5sggadNnkEmJwm","btn":"khICBJWX_hWJU4aQoTD3","extra":"k46GAkh4fTBjMehAhnZ4"};